import Service from "../../../Services/index";
import moment from "moment";

const ReceivableSeller = {
    namespaced: true,
    state: {
        sellers: [],
        search: {
            keyword: '',
            date :[
                null,
                null
            ]
        },
        dataPaginate: {
            current_page: 1,
            from: 1,
            last_page: 1,
            per_page: 1,
            total: 1,
            to: 1
        }
    },
    mutations: {
        SET_SELLERS: (state, res) => {
            state.sellers = res.data;
            state.dataPaginate = {
                current_page: res.current_page,
                from: res.form,
                last_page: res.last_page,
                per_page: res.per_page,
                total: res.total,
                to: res.to
            };
        },
        SET_SEARCH: (state, search) => {
            state.search = {
                keyword : search.keyword,
                date : [
                    search.start_date,
                    search.end_date
                ]
            }
        },
        CLEAR_SEARCH:(state)=>{
            state.search = {
                keyword: '',
                    date :[
                    null,
                    null
                ]
            }
        }
    },
    actions: {
        setSellers({ state, commit }) {
            return Service.ReceivableSellers.getSellers({
                page: state.current_page,
                keyword: state.search.keyword,
                start_date: state.search.date[0] ? moment(state.search.date[0]).format('YYYY-MM-DD') : "",
                end_date: state.search.date[1] ? moment(state.search.date[1]).format('YYYY-MM-DD') : ""

            }).then(response => {
                    commit("SET_SELLERS", response)
                })
        },
        setSearch({ commit }, search) {
            commit("SET_SEARCH", search)
        },
        clearSearch({commit}){
            commit("CLEAR_SEARCH");
        }
    }
};

export default ReceivableSeller
